<template>
    <dash
        icon="fa fa-book"
        titulo="DESPESAS"
        subTitulo="FINANCEIRO"
        @click.native="$router.push({ name: 'DespesasGerais_Financeiro_Despesas' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>